import Page from '@app/components/layout/page/page';
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsJson,
  parseAsString,
  useQueryState,
} from 'nuqs';
import { z } from 'zod';

const sortSchema = z.object({
  id: z.string(),
  desc: z.boolean(),
});

export default function PurchasedFoodAndDrinkIngredientsPage() {
  const [page] = useQueryState('page', parseAsInteger.withDefault(1));
  const [perPage] = useQueryState('perPage', parseAsInteger.withDefault(10));
  const [sort] = useQueryState('sort', parseAsJson(sortSchema.parse));
  const [errors] = useQueryState('errors', parseAsArrayOf(parseAsString));
  const [sites] = useQueryState('site', parseAsArrayOf(parseAsString));
  const [supplier] = useQueryState('supplier', parseAsArrayOf(parseAsString));
  const [period] = useQueryState('period', parseAsArrayOf(parseAsString));

  // const data = OrganizationFoodIngredientsData;

  return (
    <Page name="Food and drink" page="subpage">
      {/* <PurchasedFoodAndDrinkIngredientsTable data={data} /> */}
      <></>
    </Page>
  );
}
